import { useMediaQuery } from 'react-responsive'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

// Constants
import { PATH_HELPERS } from 'src/constants/navigation'

// Selectors
import { selectCustomerId } from 'src/store/selectors/customerProfile'

// Components
import { Button, Text } from 'src/Components'

// Helpers
import history from 'src/history'

// Assets
import emptyImage from 'src/assets/homes/img/empty.svg'

// Styles
import styles from './EmptyState.module.scss'

const EmptyState = ({ copy, ctaCopy }) => {
  const customerId = useSelector(selectCustomerId)
  const isMediumScreen = useMediaQuery({
    query: `(min-width: ${styles.mediumBreak})`,
  })
  const handleClick = () => {
    history.push(PATH_HELPERS.homeSearch.buildPath(customerId))
  }

  return (
    <div className={styles.emptySection}>
      <img src={emptyImage} alt='' className={styles.emptyImage} />
      <Text
        size={isMediumScreen ? 'l' : 'm'}
        weight='regular'
        variant='neutralCool'
        variantCount='800'
        align='center'
        className={styles.emptyText}
      >
        {copy}
      </Text>
      <Button primary onClick={handleClick}>
        {ctaCopy}
      </Button>
    </div>
  )
}

EmptyState.propTypes = {
  copy: PropTypes.object,
  ctaCopy: PropTypes.object,
}

export default EmptyState
